import { Col, Row } from "antd";
import {
  DropDown,
  InputField,
  SubmitButton,
  TimePickerInput,
  DatePickerInput,
} from "../../../../components";
import styles from "./EditCountdown.module.css";
import RoomImage from "../../../../assets/RoomImage.png";
import { CalendarIcon, ClockIcon } from "../../../../components/icons/Icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useRef, useState } from "react";
import dayjs from "dayjs";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { useDispatch } from "react-redux";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import moment from "moment";

const EditCountdown = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const countDownData = location?.state?.data;
  const [BrideName, setBrideName] = useState(
    countDownData?.bride?.name ? countDownData?.bride?.name : ""
  );
  const [GroomName, setGroomName] = useState(
    countDownData?.groom?.name ? countDownData?.groom?.name : ""
  );
  const [date, setdate] = useState(
    countDownData?.count_down?.datetime
      ? dayjs(countDownData?.count_down?.datetime)
      : ""
  );
  const [Time, setTime] = useState(
    countDownData?.count_down?.datetime
      ? dayjs(countDownData?.count_down?.datetime)
      : ""
  );

  const [image, setImage] = useState(countDownData?.image);

  // console.log("state==========>>>", setEndDate);
  const hiddenFileInputImage = useRef();
  const handleClickImage = (event) => {
    hiddenFileInputImage.current.click();
  };
  const onEditCountDown = () => {
    if (!GroomName || !BrideName || !date || !Time) {
      dispatch(
        showAlert({
          title: "Edit Count Down",
          message: "All fields are mandatory.",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else {
      let countdownData = {
        GroomName,
        BrideName,
        date: moment(date?.$d).format("YYYY-MM-DD"),
        time: moment(Time?.$d).format("HH:mm"),
        id: countDownData?.id,
        countdown_id: countDownData?.count_down?.id,
      };
      dispatch(EventMiddleware.editCountDown(countdownData))
        .then(() => navigate(-1))
        .catch((err) => console.log(err));
    }
  };
  function disabledDate(current) {
    let startDate = moment().subtract(1, "days");
    let endDate = moment(countDownData?.date).add(1, "days")
    return current < startDate || current > endDate;
  }
  return (
    <>
      <Row className={styles.row} justify={"space-between"}>
        <Col className={styles.inputColumn}>
          <InputField
            label="Name"
            inputWidth="48%"
            value={BrideName}
            disabled={true}
            onChange={(e) => setBrideName(e.target.value)}
          />
          <InputField
            label="To"
            inputWidth="48%"
            value={GroomName}
            disabled={true}
            onChange={(e) => setGroomName(e.target.value)}
          />
          <DatePickerInput
            label="Set Date"
            inputWidth="48%"
            value={date}
            disabledDate={disabledDate}
            onChange={(e) => setdate(e)}
            icon={<CalendarIcon size={25} />}
          />
          <TimePickerInput
            label="Set Time"
            inputWidth="48%"
            value={Time}
            onChange={(e) => setTime(e)}
            icon={<ClockIcon size={25} />}
          />
          <InputField
            label="Event Name"
            inputWidth="100%"
            value={countDownData?.name}
          />
          <InputField
            label="Event Category"
            inputWidth="100%"
            value={countDownData?.category?.name}
          />
          {/* <DropDown
            width="100%"
            stylesClass={styles.dropdownClass}
            name={"role"}
            label="Event Category"
            options={[
              { value: countDownData?.category?.name, option: countDownData?.category?.name },
              // { value: "Wedding", option: "Wedding" },
            ]}
          /> */}
        </Col>
        <Col className={styles.imgColumn}>
          <img
            className={styles.img}
            src={
              image
                ? typeof image === "string"
                  ? image
                  : URL.createObjectURL(image)
                : RoomImage
            }
          />
          {/* <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setImage(e.target.files[0])}
                  ref={hiddenFileInputImage}
                  style={{ display: "none" }}
                /> */}
        </Col>
      </Row>
      <SubmitButton
        title={"Save"}
        btnClass={styles.solidBtn}
        onClick={onEditCountDown}
      />
    </>
  );
};

export default EditCountdown;
